(function(){
  if (window.__brfDesignPdp) return; window.__brfDesignPdp = true;
  var doc = document;
  function info(){ return doc.querySelector('.product-block-list__item--info'); }
  function unitText(){ var u = info() && info().querySelector('.brf-unit--pdp'); return u ? u.textContent.replace(/^per\s+/, '').trim() : ''; }
  function pence(){
    var i = info(), pl = i && (i.querySelector('.product-form__info-content .price-list') || i.querySelector('.price-list'));
    var p = pl && pl.querySelector('.price:not(.price--compare)');
    var m = p && /(\d[\d,]*(?:\.\d+)?)/.exec(p.textContent);
    return m ? Math.round(parseFloat(m[1].replace(/,/g, '')) * 100) : null;
  }
  function money(c){ return '£' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  /* price first: move the Price row up so it sits straight under the title, above the colour picker */
  function priceFirst(){
    var i = info(); if (!i || i.__brfPf) return;
    var form = i.querySelector('form.product-form'); var priceRow = i.querySelector('.product-form__info-list .product-form__info-item');
    if (!form || !priceRow || !priceRow.querySelector('.price-list')) return;
    i.__brfPf = 1;
    var box = doc.createElement('div'); box.className = 'product-form__info-list brf-price-first';
    box.appendChild(priceRow);
    form.parentNode.insertBefore(box, form);
  }
  /* keep "per metre" right beside the price, ahead of the sale box that follows the price list */
  function unitBeside(){
    var i = info(); if (!i) return;
    var u = i.querySelector('.brf-unit--pdp'), pl = u && u.parentNode.querySelector('.price-list');
    if (u && pl && pl.nextElementSibling !== u) pl.parentNode.insertBefore(u, pl.nextSibling);
  }
  /* 5. ready-cut lengths: which length is chosen now ({m: metres, l: "5.5 m length"}), or null for products sold only by the metre */
  function lenMap(){
    var i = info(), s = i && i.querySelector('[data-brf-len-map]'); if (!s) return null;
    if (!s.__m) { try { s.__m = JSON.parse(s.textContent); } catch (e) { s.__m = {}; } }
    return s.__m;
  }
  function curLen(){
    var m = lenMap(); if (!m) return null;
    var i = info(), f = i && i.querySelector('form.product-form');
    var el = f && (f.querySelector('select[name="id"]') || f.querySelector('[name="id"]'));
    var v = el && m[el.value];
    return (v && v.m != null) ? v : null;
  }
  function fmtM(x){ return String(Math.round(x * 100) / 100); }
  function lenLabels(){
    var L = curLen(), i = info(); if (!L || !i) return;
    var u = i.querySelector('.brf-unit--pdp'), c = pence();
    if (u) {
      var t = L.m === 1 ? 'per metre' : 'per ' + L.l + (c != null ? ' (' + money(Math.round(c / L.m)) + '/m)' : '');
      if (u.textContent.trim() !== t) u.textContent = t;
    }
    var ql = i.querySelector('[data-brf-qlabel]');
    if (ql) { var qt = L.m === 1 ? 'Length (metres)' : 'Quantity'; if (ql.textContent !== qt) ql.textContent = qt; }
  }
  /* sticky bar: "5.5 Metres (550cm x 112cm)" -> "5.5 Metres" */
  function sabShort(){
    [].forEach.call(doc.querySelectorAll('.brf-sab__seg > span'), function(s){
      var t = s.textContent, n = t.replace(/\s*\(\s*\d+(\.\d+)?\s*cm\s*x\s*\d+(\.\d+)?\s*cm\s*\)\s*$/i, '');
      if (n && n !== t) { s.textContent = n; s.parentNode.setAttribute('title', t); }
    });
  }
  /* running total under the length picker */
  function total(){
    var L = curLen();
    var u = L ? (L.m === 1 ? 'metre' : 'length') : unitText(); if (u !== 'metre' && u !== 'roll' && u !== 'length') return;
    var sel = info() && info().querySelector('[name="quantity"]'); if (!sel) return;
    var row = sel.closest('.product-form__info-item') || sel.parentNode;
    var el = row.querySelector('.brf-len-total');
    if (!el) { el = doc.createElement('p'); el.className = 'brf-len-total'; el.setAttribute('aria-live', 'polite'); (row.querySelector('.product-form__info-content') || row).appendChild(el); }
    var q = parseInt(sel.value, 10) || 1, c = pence(); if (c == null) return;
    var html;
    if (u === 'length') {
      html = '<b>' + q + ' &times; ' + L.l + (q > 1 ? ' (' + fmtM(q * L.m) + ' m)' : '') + ' = ' + money(c * q) + '</b>'
        + (q > 1 ? '<small>Each length comes as its own piece</small>' : '<small>One ready-cut piece</small>');
    } else {
      var word = u === 'metre' ? (q === 1 ? 'metre' : 'metres') : (q === 1 ? 'roll' : 'rolls');
      html = '<b>' + q + ' ' + word + ' = ' + money(c * q) + '</b>' + (u === 'metre' ? '<small>Cut in one continuous length</small>' : '');
    }
    if (el.innerHTML !== html) el.innerHTML = html;
    var sab = doc.querySelector('.brf-sab__in'); if (sab && (u === 'metre' || u === 'length')) sab.setAttribute('aria-label', u === 'metre' ? 'Length in metres' : 'Quantity');
  }
  function run(){ priceFirst(); unitBeside(); lenLabels(); total(); sabShort(); }
  function soon(){ setTimeout(run, 40); }
  doc.addEventListener('change', soon, true);
  doc.addEventListener('input', soon, true);
  doc.addEventListener('click', soon, true);
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  /* the theme swaps the price after a length change, and the sticky bar redraws its options: follow both */
  if (window.MutationObserver) {
    var mo = new MutationObserver(function(){ clearTimeout(mo.__t); mo.__t = setTimeout(run, 30); });
    var watch = function(){
      var i = info(), pl = i && i.querySelector('.price-list'), op = doc.querySelector('[data-brf-sab-opts]');
      if (pl && !pl.__brfMo) { pl.__brfMo = 1; mo.observe(pl, {childList: true, subtree: true, characterData: true}); }
      if (op && !op.__brfMo) { op.__brfMo = 1; mo.observe(op, {childList: true, subtree: true}); }
    };
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', watch); else watch();
    window.addEventListener('load', watch);
  }
})();
